import styled from 'styled-components';
import { Button } from '@hiiretail/synergy-ui';

export const StyledButton = styled(Button)`
  width: 70px;
  
  :first-child {
    margin-right: 16px;
  }
`;
